import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg_i-process-download",
  "use": "svg_i-process-download-usage",
  "viewBox": "0 0 15 17",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 15 17\" id=\"svg_i-process-download\"><path d=\"M15 6h-4.286V0H4.286v6H0l7.5 7L15 6zM0 15v2h15v-2H0z\" fill=\"currentColor\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol